module.exports = __webpack_public_path__ + "img/ico-alarm-check.8b8117c9.svg";